import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_032",
  "use": "icon-su_032-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-su_032\"><defs><style>#icon-su_032 .cls-1{fill:none;opacity:0;}#icon-su_032 .cls-2{fill:#5ab3a0;}</style></defs><g id=\"icon-su_032_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_032_icon\"><rect class=\"cls-1\" width=\"16\" height=\"16\" /><polygon class=\"cls-2\" points=\"6.8 12.9 2.35 8.45 4.05 6.75 6.8 9.5 12.35 3.95 14.05 5.65 6.8 12.9\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol